import PmaxWorkspace from '@/components/google-ads/performance-max/PmaxWorkspace';
import { LOCAL_OBJECTIVE } from './localObjective';

/** LOCAL STORE VISITS WORKSPACE — /google-ads/local */
export default function LocalPage() {
  return <PmaxWorkspace objective={LOCAL_OBJECTIVE} />;
}
